module.exports = __webpack_public_path__ + "img/Point to Point Network.181772d0.png";